import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { INGREDIENTS_QUERY } from '../graphql/queries'
import { COMMON_FETCH_INGREDIENTS } from '../redux/action-types'
import { cleanupCommonFetchIngredients } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useIngredientsQuery = variables => {
  const defaultDisableNodes = useCallback(
    ({ isWholeFood, componentIngredients }) =>
      !isWholeFood || !isEmpty(componentIngredients),
    [],
  )

  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchIngredients)

  const { isLoading, error, data, options, groupedById } = useSelector(
    store => store.common.ingredients,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        INGREDIENTS_QUERY,
        {
          disableNodes: variables?.disableNodes
            ? variables?.disableNodes
            : defaultDisableNodes,
        },
        dispatch,
        COMMON_FETCH_INGREDIENTS,
      ),
    [defaultDisableNodes, dispatch, variables?.disableNodes],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options, groupedById }
}

export default useIngredientsQuery
